import { FC, useMemo, useState, useEffect, useCallback } from 'react';
import { useMarkModalAsSeen, useShouldDisplayModal } from '../../../api/deadbeat';
import DeadbeatModal from './DeadbeatModal';

const Deadbeat: FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { data } = useShouldDisplayModal();
  const { markModalAsSeen } = useMarkModalAsSeen();

  const shouldDisplay = useMemo(() => {
    return data?.shouldDisplayModal;
  }, [data?.shouldDisplayModal]);

  useEffect(() => {
    if (shouldDisplay?.shouldExecute) {
      setIsOpen(true);
    }
  }, [shouldDisplay?.shouldExecute]);

  const onClose = useCallback(() => {
    setIsOpen(false);
    markModalAsSeen();
  }, [markModalAsSeen]);

  if (shouldDisplay === undefined) {
    return null;
  }

  return (
    <DeadbeatModal isOpen={isOpen} data={shouldDisplay} onClose={onClose} />
  );
};

export default Deadbeat;
